/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('ProjectTestingServiceApi', ($http, ApiErrorService) => {
    return {
        getProject: getProject,
        getProjectById: getProjectById,
        getAllUserProjects: getAllUserProjects,
        getTeamProject: getTeamProject,
        archive: archive,
        unarchive: unarchive,
        clone: clone,
        changeProjectState: changeProjectState,
        saveTeamProject: saveTeamProject,
        getAllTeamProjects: getAllTeamProjects,
        getAvailableProjects: getAvailableProjects,
        getTestProjectConfigFields: getTestProjectConfigFields,
        getTestProjectFieldData: getTestProjectFieldData,
        getAllTestProjectLinksForTeam: getAllTestProjectLinksForTeam,
        getTestProjectLinkForTestProject: getTestProjectLinkForTestProject
    };
    function getProject(userId, simulatorId) {
        return $http.get(`api/ProjectTesting/GetProject?userId=${userId}&simulatorId=${simulatorId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getProjectById(projectId) {
        return $http.get(`api/ProjectTesting/GetProject?projectId=${projectId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAllUserProjects(userId) {
        return $http.get(`api/ProjectTesting/GetAllUserProjects?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTeamProject(projectId) {
        return $http.get(`api/ProjectTesting/GetTeamProject?projectId=${projectId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function archive(projectId) {
        return $http.post(`api/ProjectTesting/Archive?projectId=${projectId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function unarchive(projectId) {
        return $http.post(`api/ProjectTesting/Unarchive?projectId=${projectId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function clone(projectId) {
        return $http.post(`api/ProjectTesting/Clone?projectId=${projectId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function changeProjectState(projectId, newProjectState) {
        return $http.post(`api/ProjectTesting/ChangeProjectState?projectId=${projectId}&newProjectState=${newProjectState}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveTeamProject(project) {
        return $http.post(`api/ProjectTesting/SaveTeamProject`, project)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAllTeamProjects(teamId) {
        return $http.get(`api/ProjectTesting/GetAllTeamProjects?teamId=${teamId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAvailableProjects() {
        return $http.get(`api/ProjectTesting/GetAvailableProjects`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTestProjectConfigFields() {
        return $http.get(`api/ProjectTesting/GetTestProjectConfigFields`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTestProjectFieldData(projectId) {
        return $http.get(`api/ProjectTesting/GetTestProjectFieldData?projectId=${projectId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAllTestProjectLinksForTeam(teamId) {
        return $http.get(`api/ProjectTesting/GetAllTestProjectLinksForTeam?teamId=${teamId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTestProjectLinkForTestProject(testProjectId) {
        return $http.get(`api/ProjectTesting/GetTestProjectLinkForTestProject?testProjectId=${testProjectId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
